import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_partyIdAdapter2v7zx778kk10s as get_partyIdAdapter } from '../../../adapter/Adapter.mjs';
import {
  get_NullableStringAdapter3fffxc67fmluc as get_NullableStringAdapter,
  presentmhd0a0ip21um as present,
  get_NullableIntAdapter1poaa869odci7 as get_NullableIntAdapter,
  get_NullableBooleanAdapter3vvq2rksy333a as get_NullableBooleanAdapter,
  nullable1in0t8o94jx9t as nullable,
} from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { Present1shu3953j96zb as Present } from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Optional.mjs';
import { Companion_getInstancet6obscsk3i3d as Companion_getInstance } from '../GraphQLFloat.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { SavePartyInput3ikp23en56cie as SavePartyInput } from '../SavePartyInput.mjs';
import { Adapter1t72m9xaryzfb as Adapter } from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapter.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SavePartyInput_InputAdapterClass;
function SavePartyInput_InputAdapter() {
  if (SavePartyInput_InputAdapterClass === VOID) {
    class $ {
      s3x(reader, customScalarAdapters) {
        throw IllegalStateException().o('Input type used in output position');
      }
      n6t(writer, customScalarAdapters, value) {
        writer.n4a('partyId');
        get_partyIdAdapter().t3x(writer, customScalarAdapters, value.p6r_1);
        var tmp = value.q6r_1;
        if (tmp instanceof Present()) {
          writer.n4a('name');
          present(get_NullableStringAdapter()).r3y(writer, customScalarAdapters, value.q6r_1);
        }
        var tmp_0 = value.r6r_1;
        if (tmp_0 instanceof Present()) {
          writer.n4a('email');
          present(get_NullableStringAdapter()).r3y(writer, customScalarAdapters, value.r6r_1);
        }
        var tmp_1 = value.s6r_1;
        if (tmp_1 instanceof Present()) {
          writer.n4a('pairingRule');
          present(get_NullableIntAdapter()).r3y(writer, customScalarAdapters, value.s6r_1);
        }
        var tmp_2 = value.t6r_1;
        if (tmp_2 instanceof Present()) {
          writer.n4a('badgesEnabled');
          present(get_NullableBooleanAdapter()).r3y(writer, customScalarAdapters, value.t6r_1);
        }
        var tmp_3 = value.u6r_1;
        if (tmp_3 instanceof Present()) {
          writer.n4a('defaultBadgeName');
          present(get_NullableStringAdapter()).r3y(writer, customScalarAdapters, value.u6r_1);
        }
        var tmp_4 = value.v6r_1;
        if (tmp_4 instanceof Present()) {
          writer.n4a('alternateBadgeName');
          present(get_NullableStringAdapter()).r3y(writer, customScalarAdapters, value.v6r_1);
        }
        var tmp_5 = value.w6r_1;
        if (tmp_5 instanceof Present()) {
          writer.n4a('callSignsEnabled');
          present(get_NullableBooleanAdapter()).r3y(writer, customScalarAdapters, value.w6r_1);
        }
        var tmp_6 = value.x6r_1;
        if (tmp_6 instanceof Present()) {
          writer.n4a('animationsEnabled');
          present(get_NullableBooleanAdapter()).r3y(writer, customScalarAdapters, value.x6r_1);
        }
        var tmp_7 = value.y6r_1;
        if (tmp_7 instanceof Present()) {
          writer.n4a('animationSpeed');
          present(nullable(customScalarAdapters.q45(Companion_getInstance().j6m_1))).r3y(writer, customScalarAdapters, value.y6r_1);
        }
      }
      t3x(writer, customScalarAdapters, value) {
        return this.n6t(writer, customScalarAdapters, value instanceof SavePartyInput() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'SavePartyInput_InputAdapter', VOID, VOID, [Adapter()]);
    SavePartyInput_InputAdapterClass = $;
  }
  return SavePartyInput_InputAdapterClass;
}
var SavePartyInput_InputAdapter_instance;
function SavePartyInput_InputAdapter_getInstance() {
  return SavePartyInput_InputAdapter_instance;
}
//region block: init
SavePartyInput_InputAdapter_instance = new (SavePartyInput_InputAdapter())();
//endregion
//region block: exports
export {
  SavePartyInput_InputAdapter_instance as SavePartyInput_InputAdapter_instance74xvg8u3smu5,
};
//endregion

//# sourceMappingURL=SavePartyInput_InputAdapter.mjs.map
